export default class ModuleLoadService {
  constructor() {
    this.store = {};
    this.callbacks = {};
  }
  async load(moduleName, modulePromise) {
    const store = this.store;
    if (store[moduleName]) {
      console.warn(`模块 ${moduleName}已存在, 并将被覆盖`);
    }
    const module = await modulePromise;
    store[moduleName] = module;
    const queue = this.callbacks[moduleName];
    if (queue) {
      queue.forEach((cb) => cb(module));
    }
  }
  onLoad(moduleName, callback) {
    if (!this.callbacks[moduleName]) {
      this.callbacks[moduleName] = [];
    }
    const queue = this.callbacks[moduleName];
    queue.push(callback);
  }
}
